/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./Assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "gigiboi",
  title: "Hello everyone, my name is Andrea Rachetta",
  subTitle: emoji(
    "A passionate Computer Scientist specializing in Data Science and with experiences of building Web and Mobile Architectures with Python / Flask / Django / Fast API / JavaScript / Reactjs / Ionic / Nodejs and some other cool libraries and frameworks. Currently I am focusing in the discipline and skills of my subsidiary subject Business Science."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/gigibot-tech" ,
  linkedin: "https://www.linkedin.com/in/andrea-rachetta-0045721a4/",
  gmail: "andre.rachetta0@gmail.com",
  gitlab: "https://gitlab.com/gigibot-tech",
  //stackoverflow: "https://stackoverflow.com/users/ ",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop web and mobile architectures"
    ),
    emoji("⚡ Data Science Stack and Foundations"),
    emoji(
      "⚡ Integration of third party services and focus on communication"
    )
  ],

  /* Make Sure to include correct Iconify https://icon-sets.iconify.design/logos/ Classname */

  softwareSkills: [
    {
      skillName: "html-5",
      classname: "logos:html-5"
    },
    {
      skillName: "sass",
      classname: "logos:sass"
    },
    {
      skillName: "css3",
      classname: "logos:css-3"
    },
    {
      skillName: "JavaScript",
      classname: "logos:javascript"
    },
    {
      skillName: "reactjs",
      classname: "logos:react"
    },
    {
      skillName: "nodejs",
      classname: "logos:nodejs"
    },
    {
      skillName: "npm",
      classname: "logos:npm-icon"
    },
    {
      skillName: "MongoDB",
      classname: "logos:mongodb-icon"
    },
    {
      skillName: "GCP",
      classname: "logos:google-cloud"
    },
    {
      skillName: "azure",
      classname: "logos:azure-icon"
    },
    {
      skillName: "Power BI",
      classname: "logos:microsoft-power-bi"
    },
    {
      skillName: "seaborn",
      classname: "logos:seaborn-icon"
    },
    {
      skillName: "python",
      classname: "logos:python"
    },
    {
      skillName: "docker",
      classname: "logos:docker-icon"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Data Science", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Web Architectures",
      progressPercentage: "60%"
    },
    {
      Stack: "Data Visualization",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Some big projects you have worked on
// Hackathon vs current projects

const projects = {
  title: "Hackathons I've been part of",
  subtitle: "SOME SMALLER TECH PROJECTS WHERE I WAS PART OF (<48h)",

  projects: [


    {
      image: require("./Assets/Celonis-Logo-1.png"),
      projectName: "Dashboards visualization with Celonis",
      projectDesc: "In the hackathon organized by Bonding, a german wide student initiative, the challenge was to cluster Processes",
      footerLink: [
        {
          name: "Visit Event Website",
          url: "https://hackathon.bonding.de/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./Assets/tech4goodhackathon.jpg"),
      projectName: "Tech4Good - Tech4Dogs",
      projectDesc: "First experience with building API's and a cross disciplinary full team with UX Designing, Project Proposals, etc.",
      footerLink: [
        {
          name: "Visit Event Page",
          url: "https://www.notion.so/techlabs/Tech4Good-Hackathon-2022-Event-Overview-3e7190e348a84e7a80254289d28be0af"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      display: true,
      image: require("./Assets/hackzurich.png"),
      projectName: "HackZurich - Zurich Insurance - Telling the climate Story",
      projectDesc: "First HackZurich entry with a full team, trying to tell the effects of climate change in Swiss",
      footerLink: [
        {
          name: "Visit Hackzurich",
          url: "https://hackzurich.com/"
        }
        //  you can add extra buttons here.
      ]
    },

    {
      image: require("./Assets/bmtwhu.png"),
      projectName: "Business meets Tech - building an application for a sports company with azure",
      projectDesc: "trying to create an innovative application where you can buy and customize an ebike",
      footerLink: [
        {
          name: "Visit Event Website",
          url: "https://www.businessmeetstech.de/"
        }
        //  you can add extra buttons here.
      ]
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

const projects2 = {
  title: "Bigger Projects",
  subtitle: "SOME PUBLIC TECH PROJECTS WHERE I AM PART OF",
  projects: [

    {
      image: require("./Assets/pads.jpg"),
      projectName: "Temporal Conformance Checking in Python",
      projectDesc: "First practical project in academia at RWTH Aachen University at the PADS chair, where with help of process mining we visualized temporal deviations in event logs",
      footerLink: [
        {
          name: "private project",
          url: "http://"
        }
        //  you can add extra buttons here.
      ]
    },

    {
      image: require("./Assets/tl_aachen.png"),
      projectName: "Food Tracker",
      projectDesc: "By the global student initiative TechLabs with its branch in Aachen. See our medium article and the certificate for more information about the project",
      footerLink: [
        {
          name: "Visit Medium Article",
          url: "https://techlabs-aachen.medium.com/blogpost-gruppe-16-de700be2ab48"
        }
        //  you can add extra buttons here.
      ]
    },
  
    {
      //image: 'coming soon'// require("./assets/images/nextuLogo.webp"),
      image: require("./Assets/logo.png"),
      projectName: "GiGi Learn",
      projectDesc: "working startup project -Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Launched V1",
          url: "http://gigilingo.netlify.app"
        }
      ]
    },

    {
      projectName: "vManga",
      projectDesc: "current project - with Object Character Recognition (OCR) in GCP for extracting vocabulary in pictures",
      footerLink: [
        {
          name: "private project",
          url: "http://"
        }
        //  you can add extra buttons here.
      ]
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "+92-0000000000",
  email_address: "andrea.rachetta@rwth-aachen.de"
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,

  skillsSection,
  techStack,
  projects,
  projects2,
  contactInfo,
  isHireable
};


// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Working Student",
      company: "smartlab mbH",
      //companylogo: require("./assets/images/facebookLogo.png"),
      date: "February 2022 – October 2022",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Operations Team Member (voluntarily)",
      company: "TechLabs Aachen",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "October 2022 – present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

